"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.phases = void 0;
/**
 * The phases a dumbapp execution goes through, in order.
 *
 * They are defined in this way so that we can both use the keys in order
 * at runtime, and TypeScript can derive types from it.
 */
const phases = exports.phases = Object.freeze({
  /**
   * Prepare a new request by setting a timestamp and determining the correct dumbapp.
   */
  prepareRequest: null,
  /**
   * Prepare the user's wallet, and create a unique ID for the submission.
   *
   * There must be exactly one handler.
   */
  prepareWallet: null,
  /**
   * Additional handlers called before user input is collected.
   */
  preInput: null,
  /**
   * Collect user input.
   */
  input: null,
  /**
   * Additional handlers called after user input is collected.
   */
  postInput: null,
  /**
   * Resolve all dumbapp arguments needed for the smart contract function calls.
   */
  resolve: null,
  /**
   * Load contract data for all steps if applicable.
   */
  loadContracts: null,
  /**
   * Additional handlers called after arguments are resolved, before the dumbapp is
   * executed.
   */
  preExecute: null,
  /**
   * Execute the dumbapp.
   *
   * There must be exactly one handler.
   */
  execute: null,
  /**
   * Act on an execution result, either success or failure.
   */
  result: null
});

/**
 * Phase handler types.
 */

/**
 * Names of the different phases.
 */

/**
 * Prepare a new request by setting a timestamp and determining the correct dumbapp.
 */

/**
 * Prepare the user's wallet, and create a unique ID for the submission.
 *
 * There must be exactly one handler.
 */

/**
 * Collect user input.
 */

/**
 * Resolve all dumbapp arguments needed for the smart contract function calls.
 */

/**
 * Load contract data for all applicable steps so execution handlers can use them.
 */

/**
 * Additional handlers called in other phases.
 */

/**
 * Result type for the data execution phase handlers should return.
 */

/**
 * Execute the dumbapp.
 *
 * There must be exactly one handler.
 */

/**
 * Act on an execution result, either success or failure.
 */

/**
 * Error result from a phase handler. This is the type that
 * handlers should return when encountering errors.
 */

/**
 * Result type for what handlers should return.
 */

/**
 * An error result that the ExecutionController provides
 * as an overall result, which includes the state of the execution.
 */

/**
 * Result type for the overall execution that the ExecutionController
 * ends with.
 */
//# sourceMappingURL=ExecutionPhases.js.map